import { ArrowChevronRight } from '@teamsparta/stack-icons';
import { vars } from '@teamsparta/stack-tokens';
import Image from 'next/legacy/image';

import type { WebinarCourseType } from '@/api/webinar';
import { COURSE_LANDING_URL, PLUS_BACKEND, REBOOT } from '@/constants';
import { sendLog } from '@/lib/utils/send-log';

import * as S from './CourseBanner.style';
type SalesBannerProps = {
  className?: string;
  course: WebinarCourseType;
};
const CourseBanner = ({ className, course }: SalesBannerProps) => {
  const getSaleBanner = (course: WebinarCourseType) => {
    switch (course) {
      case 'full':
        return (
          <>
            <S.ImageWrapper>
              <Image
                src={`${process.env.NEXT_PUBLIC_CDN_BASE_URL}/hanghae99/webinar/banner_hh.png?ver=2`}
                alt='항해 리부트 배너'
                layout='fill'
              />
            </S.ImageWrapper>
            <S.Wrapper>
              <S.TextWrapper>
                알고리즘, 프로젝트를 보완하고
                <br />
                개발자 취업에 성공하고 싶다면?
              </S.TextWrapper>
              <ArrowChevronRight size={16} color={vars.neutral[0]} />
            </S.Wrapper>
          </>
        );
      case 'plus-backend':
        return (
          <>
            <S.ImageWrapper>
              <Image
                src={`${process.env.NEXT_PUBLIC_CDN_BASE_URL}/hanghae99/webinar/banner_hhplus.png`}
                alt='항해 배너'
                layout='fill'
              />
            </S.ImageWrapper>
            <S.Wrapper>
              <S.TextWrapper>
                개발자 커리어에 플러스가 될 도전,
                <br /> 항해 플러스가 궁금하다면?
              </S.TextWrapper>
              <ArrowChevronRight size={16} color={vars.neutral[0]} />
            </S.Wrapper>
          </>
        );
      case 'plus':
        return (
          <>
            <S.ImageWrapper>
              <Image
                src={`${process.env.NEXT_PUBLIC_CDN_BASE_URL}/hanghae99/webinar/banner_hhplus.png`}
                alt='항해 배너'
                layout='fill'
              />
            </S.ImageWrapper>
            <S.Wrapper>
              <S.TextWrapper>
                개발자 커리어에 플러스가 될 도전,
                <br /> 항해 플러스가 궁금하다면?
              </S.TextWrapper>
              <ArrowChevronRight size={16} color={vars.neutral[0]} />
            </S.Wrapper>
          </>
        );
    }
  };

  const getUrl = (course: WebinarCourseType) => {
    switch (course) {
      case 'full':
        return COURSE_LANDING_URL[REBOOT];
      case 'plus-backend':
        return COURSE_LANDING_URL[PLUS_BACKEND];
      case 'plus':
        return 'https://hhplus-hub.oopy.io/';
    }
  };
  const onClickBanner = (course: WebinarCourseType) => {
    sendLog('hh_webinarDetailPage_Banner_click', {
      coursetype: course,
    });
  };
  return (
    <S.Banner
      className={className}
      course={course}
      href={getUrl(course)}
      onClick={() => onClickBanner(course)}
      target='_blank'
      rel='noopener noreferrer'
    >
      {getSaleBanner(course)}
    </S.Banner>
  );
};
export default CourseBanner;
